import dom from "../../../../../../dist/jsx-render/dom";
import { app } from "../../../../../Frame/App";
//import { isArray } from "jquery";

class MultiCategoryItem {
    public checked: boolean;
    public name: string;
}

export class CategoryFunctions {

    public static createMultiCategoryItems(element: HTMLElement) {
        let multiCategoryElements = element.querySelectorAll("[data-multi-category]");

        multiCategoryElements.forEach(e => {
            let mcElement = e as HTMLElement;
            let categoryId = mcElement.getAttribute("data-multi-category")

            const urlParams = new URLSearchParams(window.location.search);
            const measureIdString = urlParams.get("parentId");
            if (measureIdString) {
                let measureId = Number(measureIdString);
                if (!isNaN(measureId)) {
                    $.ajax({
                        url: app.resolveUrl(`~/api/dynamic/getMcMeasureValues/${categoryId}/${measureId}`),
                        method: "GET",
                        success: (response) => {
                            if (Array.isArray(response)) {
                                let responseItems = response as MultiCategoryItem[];

                                for (let item of responseItems) {
                                    let input: HTMLInputElement = <input type="checkbox" readonly="true" />;
                                    input.disabled = true;
                                    if (item.checked) {
                                        input.checked = true;
                                    }

                                    let itemElement = <div className="multi-category-item">
                                        {input}
                                        {item.name}
                                    </div>;

                                    mcElement.appendChild(itemElement);
                                }
                            }
                        },
                        error: (err) => console.log(err)
                    });
                }
            }
        });
    }

}